"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.solveByRetType = void 0;
const closure_1 = require("../closure");
const ctx_1 = require("../ctx");
const exp_1 = require("../exp");
const solution_1 = require("../solution");
const unify_1 = require("../unify");
const freshen_1 = require("../utils/freshen");
const Values = __importStar(require("../value"));
const Insertions = __importStar(require("./Insertion"));
function solveByRetType(mod, ctx, type, args, retType) {
    const argsFreeNames = new Set(args.flatMap((arg) => Array.from((0, exp_1.freeNames)(new Set(), arg.exp))));
    const insertions = [];
    while (type["@kind"] === "PiImplicit") {
        try {
            (0, unify_1.unifyType)(mod, ctx, type, retType);
            return insertions;
        }
        catch (_error) {
            // NOTE Be careful about scope bug, `freshName` might occurs in `args`.
            const name = type.retTypeClosure.name;
            const usedNames = [
                ...(0, ctx_1.ctxNames)(ctx),
                ...(0, solution_1.solutionNames)(mod.solution),
                ...argsFreeNames,
            ];
            const freshName = (0, freshen_1.freshen)(usedNames, name);
            const patternVar = Values.PatternVar(type.argType, freshName);
            ctx = (0, ctx_1.CtxFulfilled)(freshName, type.argType, patternVar, ctx);
            type = (0, closure_1.closureApply)(type.retTypeClosure, patternVar);
            insertions.push(Insertions.InsertionPatternVar(patternVar));
        }
    }
    (0, unify_1.unifyType)(mod, ctx, type, retType);
    return insertions;
}
exports.solveByRetType = solveByRetType;
//# sourceMappingURL=solveByRetType.js.map